import type { ModelsFeaturedClub } from '@/api/generated-api'

/**
 * Member cards for the For Clubs landing: the first `limit` featured clubs of
 * the selected sport, in the order the admin set on the showcase (BAT-847).
 */
export function pickMemberClubs(
  clubs: ModelsFeaturedClub[],
  sportType: string | undefined,
  limit: number
): ModelsFeaturedClub[] {
  const filtered = sportType
    ? clubs.filter(c => c.sport_type === sportType)
    : clubs
  return filtered.slice(0, limit)
}
